document.addEventListener("DOMContentLoaded", function() {

	const $ = jQuery.noConflict(),
			win = $(window),
			body_height = $('body .wp-site-blocks').height(),
			win_height = win.height(),
			pageUrl = window.location.href;

	function isTouchDevice(){
		return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
	}

	$('.wpcf7-select, .acf-form select').select2( { minimumResultsForSearch: 20 } );

    /**
	 * Mobile Menu Toggle
	 */
	if ($("body").hasClass("menu-open")) {
		$('body').removeClass("menu-open");
	} else {
		$('body').toggleClass("menu-open");
	}

	$('body').removeClass("menu-open");


	$('.header-nav-overlay').on('click', function() {
		$('body').removeClass("menu-open");
	});

	$('.wp-header-menu-container .navbar-nav>.menu-item a').each(function() {
		const target = $(this).attr('href');
		if( pageUrl === target ) {
			$(this).parent('.nav-item').addClass('menu-item-current');
		} else {
			$(this).parent('.nav-item').removeClass('menu-item-current');
		}
	});

    /**
	 * Switcher Dark Mode
	 */
	const darkTheme = "dark-theme";
	const darkThemeSetUp = () => {
		if (getCurrentTheme() === "dark") {
			document.getElementById("toggleBtn").checked = true;
		} else {
			document.getElementById("toggleBtn").checked = false;
		}
	};
	const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? "dark" : "light";
	const selectedTheme = localStorage.getItem("selected-theme");
	if (selectedTheme === "dark") {
		document.body.classList[selectedTheme === "dark" ? "add" : "remove"](
			darkTheme
		);
		darkThemeSetUp();
	}
	const themeButton = document.getElementById("toggleBtn");

	if ($("body").hasClass("light-dark")) {
		// console.log('btn active');
		$(".switcher-darkmode").css("display","block");

		themeButton.addEventListener("change", () => {
			document.body.classList.toggle(darkTheme);
			localStorage.setItem("selected-theme", getCurrentTheme());
			darkThemeSetUp();
		});
		
	} else {
		// console.log('btn not active');
		$(".switcher-darkmode").css("display","none");
	}

	if ($("body").hasClass("wp-search")) {
		$(".top-searchbox").css("display","block");
	} else {
		$(".top-searchbox").css("display","none");
	}

	/**
	 * Switching Cart
	 */
	if ($("body").hasClass("woo-cart")) {
		$(".top-minicart").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".top-minicart").css("display","none");
	}

	/**
	 * Switching Account Btn
	 */
	if ($("body").hasClass("woo-account")) {
		$(".block-account").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".block-account").css("display","none");
	}

	/**
	 * Switching Flags Btn
	 */
	if ($("body").hasClass("menu-flags")) {
		$(".block-polylang").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".block-polylang").css("display","none");
	}

	if ( $("body nav.header-nav").hasClass("megamenu") ) { 
		$(".navbar-toggler-btn").css({"display":"none"});
	} else {
		$(".navbar-toggler-btn").css({"display":"block"});
	}
    
});

// search input bar 
document.addEventListener('DOMContentLoaded', function() {
    const searchForms = document.querySelectorAll('.wp-block-search');
    
    searchForms.forEach(function(form) {
        const searchButton = form.querySelector('.wp-block-search__button');
        const searchInput = form.querySelector('.wp-block-search__input');
        
        searchButton.addEventListener('click', function(e) {
            if (window.innerWidth <= 768 && !form.classList.contains('is-active')) {
                e.preventDefault();
                form.classList.add('is-active');
                searchInput.focus();
            }
        });
		
        document.addEventListener('click', function(e) {
            if (window.innerWidth <= 768 && !form.contains(e.target)) {
                form.classList.remove('is-active');
            }
        });
    });
});